var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('asc-accent-button',{attrs:{"button-text":_vm.buttonText,"disabled":_vm.disabled,"on-click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }